export const EMPTY_VALUE = '—';

// en-GB rather than the browser locale so a date reads the same for every reviewer on a study,
// and 24-hour time so a clinical timestamp is never ambiguous.
const DATE_TIME = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

const TIME_WITH_SECONDS = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

export const formatDateTime = (value, options = {}) => {
  if (!value) {
    return EMPTY_VALUE;
  }

  return new Date(value).toLocaleString('en-GB', { ...DATE_TIME, ...options });
};

export const formatLocalDateTime = (value) => {
  if (!value) {
    return EMPTY_VALUE;
  }

  return new Date(value).toLocaleString(undefined, DATE_TIME);
};

export const formatUtcTime = (value) => {
  if (!value) {
    return EMPTY_VALUE;
  }

  return new Date(value).toLocaleTimeString('en-GB', { ...TIME_WITH_SECONDS, timeZone: 'UTC' });
};
